enum VersionedEntityType {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  REVIEW = 'REVIEW',
  ARCHIVED_REVIEW = 'ARCHIVED_REVIEW',
  ARCHIVED_PUBLISHED = 'ARCHIVED_PUBLISHED'
}

enum VersionedEntityOperationType {
  ADDED = 'ADDED',
  CHANGED = 'CHANGED',
  REMOVED = 'REMOVED'
}

type VersionedEntity = {
  derivativeOperationType?: VersionedEntityOperationType | null;
  versionType?: VersionedEntityType;
  operationType?: VersionedEntityOperationType;
};

const computeFinalOperationType = (
  entity: VersionedEntity | null | undefined
): VersionedEntityOperationType | null => {
  if (entity?.derivativeOperationType != null) return entity.derivativeOperationType;
  if (entity?.versionType === VersionedEntityType.DRAFT) return entity.operationType ?? null;
  return null;
};

export { VersionedEntityOperationType, VersionedEntityType, computeFinalOperationType };
export type { VersionedEntity };
